import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {Json} from "@cm/graph-v3"
import {jsonSchema} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import {fundamentalLikeNode, type FundamentalLikeNode} from "#template/role-markers"

// Values bound to a `Parameters` node — always FT-typed or raw JSON. Runtime validation uses the
// `fundamentalLikeNode` zod schema (checks the `fundamentalLikeMarker` symbol).
export type TemplateParameterValue = Json | FundamentalLikeNode<unknown> | FundamentalLikeNode<unknown>[]

export type ParametersParameters = {
    [x: string]: TemplateParameterValue | undefined
}

const parametersDefinition: TemplateNodeDefinition<ParametersParameters> = {
    nodeClass: "Parameters",
    validation: {
        parameters: z.record(z.string(), z.optional(z.union([fundamentalLikeNode, z.array(fundamentalLikeNode), jsonSchema]))),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class Parameters extends TemplateNode<ParametersParameters> {
    public override get definition() {
        return parametersDefinition
    }
}
